import { useMemo } from "react";
import { BUTTON_LABELS, CONFIG_PAGES } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { IInspectionTemplateListItemResponse } from "@miplatform/types";
import { mdiChevronDown, mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { useTheme } from "@mui/material";
import { MODULES_CONFIG_PATHS } from "../../../../routes/config/constants";
import { ConfigCard, ConfigMenu } from "../../components";

export const ConfigInspectionTemplateCard = ({
  item,
  handleOpenDeleteModal,
  updateInspectionTemplate,
  canDeleteInspectionTemplate,
  canUpdateInspectionTemplate,
}: {
  item: IInspectionTemplateListItemResponse;
  handleOpenDeleteModal: (item: IInspectionTemplateListItemResponse) => void;
  updateInspectionTemplate: (
    data: Partial<IInspectionTemplateListItemResponse>,
    name?: string
  ) => void;
  canUpdateInspectionTemplate: boolean;
  canDeleteInspectionTemplate: boolean;
}) => {
  const theme = useTheme();
  const { navigate } = useRouter();

  const navigateToInspectionTemplateDetails = () => {
    navigate(
      `${
        MODULES_CONFIG_PATHS[CONFIG_PAGES.MI_INSPECTIONS][
          CONFIG_PAGES.INSPECTION_TEMPLATES
        ]
      }/${item.id}`
    );
  };

  const menuActions = useMemo(() => {
    const actions = [];

    if (canUpdateInspectionTemplate) {
      actions.push({
        label: BUTTON_LABELS.EDIT,
        action: navigateToInspectionTemplateDetails,
        icon: mdiPencilOutline,
      });
    }

    if (canDeleteInspectionTemplate) {
      actions.push({
        label: BUTTON_LABELS.DELETE,
        action: () => handleOpenDeleteModal(item),
        icon: mdiTrashCanOutline,
        color: theme.palette.error.main,
      });
    }

    return actions;
  }, [canUpdateInspectionTemplate, canDeleteInspectionTemplate, item]);

  return (
    <ConfigCard
      title={item.name}
      modifiedOn={item.modifiedOn}
      onClick={navigateToInspectionTemplateDetails}
      menuActions={menuActions}
      customAction={
        <ConfigMenu
          data={[
            {
              label: item.isActive ? "Draft" : "Activate",
              action: () => {
                const data = {
                  id: item.id,
                  modifiedOn: item.modifiedOn,
                  isActive: !item.isActive,
                };
                updateInspectionTemplate(data, item.name);
              },
            },
          ]}
          optionalElement={{
            size: "small",
            title: item.isActive ? "Active" : "Draft",
            color: item.isActive ? "success" : "orange",
            endIcon: { path: mdiChevronDown },
            sx: { width: 85 },
          }}
        />
      }
    />
  );
};
